module.exports = __webpack_public_path__ + "static/media/29BDOS22.82700fd9.jpg";